import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";
import { eventApi } from "@circle-react/api/eventApi";

type QueryKeyType = readonly ["workflows", "list", "upcomingEvents"];

interface Event {
  id: string;
  name: string;
  paid_event: boolean;
  recurring: boolean;
  space_name: string;
  start_date: string;
  ticket_price: string;
}

interface UpcomingEventsResponse {
  records: Event[];
}

export const useFetchUpcomingEvents = ({
  per_page,
  location_type = "",
  options = {},
}: {
  per_page: number;
  location_type?: string;
  options?: Omit<
    UseQueryOptions<
      UpcomingEventsResponse,
      unknown,
      UpcomingEventsResponse,
      QueryKeyType
    >,
    "queryKey" | "queryFn"
  >;
}) =>
  useQuery(
    ["workflows", "list", "upcomingEvents"] as const,
    () =>
      eventApi.fetchUpcomingEvents({
        params: { per_page, location_type },
      }),
    options,
  );
